/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 4b91f6a68eb56575e112b2a00fcb982a646b9233866775f5377f5b42a842e636
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './Dropdown.style'

export const DropdownCompositionDependencies = ['Overlay'] as const

type DropdownOwnProps = {
  className?: string
  children?: React.ReactNode
  emptyDescription?: React.ReactNode
  emptyTitle?: string
  footer?: React.ReactNode
  header?: React.ReactNode
  isFooterAbsolute?: boolean
  search?: React.ReactNode
  state?: 'default' | 'empty'
}

export type DropdownProps = DropdownOwnProps & Omit<ComponentProps<'div'>, keyof DropdownOwnProps>

function Dropdown(props: DropdownProps): ReactElement {
  const {
    children,
    className = '',
    emptyDescription,
    emptyTitle = 'No matching results',
    footer,
    header,
    isFooterAbsolute = true,
    search,
    state = 'default',
    ...rest
  } = props

  return (
    <div
      className={cn('Dropdown', className, { isFooterAbsolute })}
      css={style}
      {...rest}
      role='menu'
    >
      {header}
      {search}
      {state === 'empty' ? (
        <>
          {emptyTitle}
          {emptyDescription}
        </>
      ) : (
        children
      )}
      {footer}
    </div>
  )
}

export default Dropdown
